<template>
  <svg
    :width="widhei"
    :height="widhei"
    class="svg-hover"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
      stroke="#C2C2D6"
      :stroke-width="strwidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5 6.5L6.5 11.5"
      stroke="#C2C2D6"
      :stroke-width="strwidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 6.5L11.5 11.5"
      stroke="#C2C2D6"
      :stroke-width="strwidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    strwidth: {
      type: [Number, String],
      default: 2,
    },
    widhei: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>
